import { render } from "./WinnersAwards.vue?vue&type=template&id=5065a50c"
import script from "./WinnersAwards.vue?vue&type=script&lang=js"
export * from "./WinnersAwards.vue?vue&type=script&lang=js"

import "./WinnersAwards.vue?vue&type=style&index=0&id=5065a50c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__